import { Clock } from "lucide-react";
import { DAYS } from "@/lib/api";

const fmt = (hm) => {
  const [h, m] = hm.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "pagi" : h < 19 ? "petang" : "malam"}`;
};

export function ClosedNotice({ shop, className = "mt-6" }) {
  const off = (shop.closed_days || []).map((d) => DAYS[d]).join(", ");
  return (
    <div className={`${className} rounded-2xl border border-red-200 bg-red-50 p-4 flex gap-3`} data-testid="shop-closed-notice">
      <Clock className="w-6 h-6 text-red-600 shrink-0" />
      <div className="text-sm">
        <p className="font-display font-bold text-red-700">Kedai Tutup</p>
        <p className="text-slate-600">Pesanan dibuka {fmt(shop.open_time)} – {fmt(shop.close_time)}{off ? `, tutup setiap ${off}` : ""}.</p>
      </div>
    </div>
  );
}
